<script setup lang="ts">
import { onMounted, watch } from "vue";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import { useCurrentUserStore } from "@app/store/modules/currentUser";
import { useAuthStore } from "@shared/store/modules/auth";

const auth = useAuthStore();
const currentUserStore = useCurrentUserStore();

async function bootstrapSession() {
    await currentUserStore.fetchIfNeeded();
}

function resetSession() {
    currentUserStore.reset();
}

onMounted(() => {
    if (auth.token) bootstrapSession();
});

watch(
    () => auth.token,
    token => {
        if (!token) resetSession();
        else bootstrapSession();
    },
);
</script>

<template>
    <el-config-provider :locale="zhCn">
        <router-view />
    </el-config-provider>
</template>
